import * as React from 'react'

type Props = {
  children: (size: {
    width: number
    height: number
    isDesktop?: boolean
  }) => React.ReactNode | null | undefined
}
type State = {
  width: number
  height: number
  isDesktop?: boolean
}

class Viewport extends React.Component<Props, State> {
  state: State = {
    width: 0,
    height: 0,
    isDesktop: undefined,
  }
  static getWidth = () =>
    typeof window !== 'undefined'
      ? Math.max(
          document.documentElement ? document.documentElement.clientWidth : 0,
          window.innerWidth || 0,
        )
      : 0
  static getHeight = () =>
    typeof window !== 'undefined'
      ? Math.max(
          document.documentElement ? document.documentElement.clientHeight : 0,
          window.innerHeight || 0,
        )
      : 0
  static isDesktop = () => Viewport.getWidth() >= 992

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    const width = Viewport.getWidth()
    const height = Viewport.getHeight()
    const isDesktop = Viewport.isDesktop()
    this.setState({
      width,
      height,
      isDesktop,
    })
  }

  render() {
    return this.state ? this.props.children(this.state) : null
  }
}

export default Viewport
